/* Cuisine Inspirante — offres de la fiche produit (paliers, barre livraison, coffret apéritif)
   - Les paliers pilotent le sélecteur de variantes du thème (masqué une fois ce script prêt) :
     prix, galerie, bouton d'ajout, panier tiroir, ruptures et erreurs restent gérés par le thème.
   - Le coffret ajoute ses articles en un seul appel au panier ; la remise « Coffret apéro »
     est une remise automatique Shopify, calculée au panier (ce script ne fait qu'afficher une estimation).
   - Le cadeau est géré par ci-gift-guard.js (chargé sur tout le site). */
(function () {
  if (window.__ciOffersInit) return;
  window.__ciOffersInit = true;

  function money(cents, format) {
    var f = format || '{{amount_with_comma_separator}} €';
    var v = (Math.round(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withComma = intPart + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_with_comma_separator': return withComma;
        case 'amount_no_decimals_with_comma_separator': return intPart;
        case 'amount_with_space_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
        case 'amount_no_decimals': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        default: return withDot;
      }
    });
  }

  function pubsub() {
    /* PUB_SUB_EVENTS est une constante globale du thème (pas une propriété de window). */
    var ev = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null; // eslint-disable-line no-undef
    return {
      ev: ev,
      pub: (ev && typeof publish === 'function') ? publish : null, // eslint-disable-line no-undef
      sub: (ev && typeof subscribe === 'function') ? subscribe : null // eslint-disable-line no-undef
    };
  }

  function init() {
    var root = document.querySelector('[data-ci-offers]');
    var pack = document.querySelector('[data-ci-pack]');
    if (!root && !pack) return;

    var anchor = root || pack;
    var info = anchor.closest('.product__info-wrapper') || anchor.closest('.product__info-container') || anchor.closest('section') || document;
    var fmt = (root && root.dataset.moneyFormat) || '{{amount_with_comma_separator}} €';
    var picker = info.querySelector('variant-radios, variant-selects');
    var mainForm = info.querySelector('product-form form') || document.querySelector('product-form form');
    var idInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
    var tiers = root ? Array.prototype.slice.call(root.querySelectorAll('input[type="radio"][name^="ci-of-"]')) : [];

    function currentTier() {
      var id = idInput ? String(idInput.value) : '';
      var hit = tiers.filter(function (t) { return t.value === id; })[0];
      return hit || tiers.filter(function (t) { return t.checked; })[0] || null;
    }

    function paint(sel) {
      tiers.forEach(function (t) {
        var on = t === sel;
        t.checked = on;
        var lab = t.closest('[data-ci-tier]');
        if (lab) lab.classList.toggle('is-sel', on);
      });
    }

    function drivePicker(inp) {
      if (!picker) return;
      var opt = inp.dataset.option;
      if (picker.tagName === 'VARIANT-RADIOS') {
        var radios = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
        var r = radios.filter(function (x) { return x.value === opt; })[0];
        if (r && !r.checked) r.click();
      } else {
        var s = picker.querySelector('select');
        if (s && s.value !== opt) { s.value = opt; s.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }

    /* ---------- Barre livraison offerte ---------- */
    var ship = root ? root.querySelector('[data-ci-ship]') : null;
    var threshold = root ? parseInt(root.dataset.freeShipping || '0', 10) : 0;
    var cartTotal = null;
    function refreshCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; })
        .catch(function () { cartTotal = null; });
    }
    function paintShip() {
      if (!ship || !threshold || cartTotal === null) return;
      var sel = currentTier();
      var add = sel ? parseInt(sel.dataset.price || '0', 10) : 0;
      var total = cartTotal + add;
      var left = threshold - total;
      var txt = ship.querySelector('[data-ci-ship-txt]');
      var bar = ship.querySelector('[data-ci-ship-bar]');
      ship.hidden = false;
      if (left <= 0) {
        ship.classList.add('is-done');
        txt.textContent = cartTotal > 0 ? 'Livraison offerte en France pour cette commande' : 'Livraison offerte en France avec ce format';
        bar.style.width = '100%';
      } else {
        ship.classList.remove('is-done');
        txt.innerHTML = 'Plus que <b>' + money(left, fmt) + '</b> pour la livraison offerte en France' + (cartTotal > 0 ? '' : ' avec ce format');
        bar.style.width = Math.max(4, Math.min(100, Math.round(total / threshold * 100))) + '%';
      }
    }

    /* ---------- Coffret apéritif ---------- */
    function paintPack() {
      if (!pack) return;
      var sel = currentTier();
      var lotPrice = sel ? parseInt(sel.dataset.price || '0', 10) : 0;
      var lotName = sel ? sel.closest('[data-ci-tier]').querySelector('.ci-of__name').textContent.trim() : '';
      var extras = Array.prototype.slice.call(pack.querySelectorAll('[data-ci-pack-extra]'));
      var chosen = extras.filter(function (x) { return x.checked; });
      var sum = lotPrice + chosen.reduce(function (a, x) { return a + parseInt(x.dataset.price || '0', 10); }, 0);
      var count = 1 + chosen.length;
      var pct = parseInt(pack.dataset.pct || '0', 10);
      var min = parseInt(pack.dataset.min || '3', 10);
      var ok = pct > 0 && count >= min;
      var lotLbl = pack.querySelector('[data-ci-pack-lot]');
      if (lotLbl && lotName) lotLbl.textContent = lotName + ', format choisi ci-dessus';
      var lotPr = pack.querySelector('[data-ci-pack-lotprice]');
      if (lotPr && sel) lotPr.textContent = money(lotPrice, fmt);
      pack.querySelector('[data-ci-pack-val]').textContent = money(ok ? Math.round(sum * (100 - pct) / 100) : sum, fmt);
      var lbl = pack.querySelector('[data-ci-pack-lbl]');
      lbl.firstChild.nodeValue = ok ? 'Prix estimé du coffret' : 'Total de la sélection';
      pack.querySelector('[data-ci-pack-sep]').textContent = ok ? 'Acheté séparément : ' + money(sum, fmt) : '';
      var btn = pack.querySelector('[data-ci-pack-add]');
      if (!btn.classList.contains('is-busy')) btn.textContent = count === extras.length + 1 ? 'Ajouter le coffret au panier' : 'Ajouter la sélection au panier';
      var off = sel && sel.disabled;
      btn.disabled = !!off;
    }

    function packStatus(msg, isErr) {
      var st = pack.querySelector('[data-ci-pack-status]');
      st.textContent = msg || '';
      st.hidden = !msg;
      st.classList.toggle('is-err', !!isErr);
    }

    function addPack() {
      var sel = currentTier();
      var lotId = idInput ? idInput.value : (sel ? sel.value : null);
      if (!lotId) return;
      var btn = pack.querySelector('[data-ci-pack-add]');
      var items = [{ id: Number(lotId), quantity: 1 }];
      pack.querySelectorAll('[data-ci-pack-extra]').forEach(function (x) {
        if (x.checked) items.push({ id: Number(x.value), quantity: 1 });
      });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('is-busy');
      btn.textContent = 'Ajout en cours…';
      packStatus('');
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            packStatus(data.description || data.message || "Le coffret n'a pas pu être ajouté au panier. Réessayez dans un instant ou écrivez-nous si le problème continue.", true);
            return;
          }
          var ps = pubsub();
          if (ps.pub) { try { ps.pub(ps.ev.cartUpdate, { source: 'ci-offers', cartData: data }); } catch (e) {} }
          if (window.Vanga && typeof window.Vanga.refresh === 'function') {
            // Panier de l'appli Vanga (remplace le tiroir du thème quand elle est active)
            try { window.Vanga.refresh(); if (typeof window.Vanga.open === 'function') window.Vanga.open(); } catch (e) {}
          } else if (drawer && data.sections && drawer.renderContents) {
            drawer.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          packStatus("Le coffret n'a pas pu être ajouté au panier. Réessayez dans un instant ou écrivez-nous si le problème continue.", true);
        })
        .finally(function () {
          btn.classList.remove('is-busy');
          btn.disabled = false;
          paintPack();
          refreshCart().then(paintShip);
        });
    }

    /* ---------- Branchements ---------- */
    if (root && picker && tiers.length) {
      info.classList.add('ci-of-ready');
      root.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || tiers.indexOf(t) === -1) return;
        paint(t);
        drivePicker(t);
        paintShip();
        paintPack();
      });
    }
    if (idInput) {
      // Si le thème change la variante (lien ?variant=, retour arrière…), on suit.
      var last = idInput.value;
      new MutationObserver(function () {
        if (idInput.value === last) return;
        last = idInput.value;
        var s = currentTier();
        if (s) paint(s);
        paintShip();
        paintPack();
      }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      if (picker) picker.addEventListener('change', function () {
        setTimeout(function () { var s = currentTier(); if (s) paint(s); paintShip(); paintPack(); }, 60);
      });
    }
    if (pack) {
      pack.addEventListener('change', function (e) { if (e.target.hasAttribute('data-ci-pack-extra')) paintPack(); });
      pack.querySelector('[data-ci-pack-add]').addEventListener('click', addPack);
    }
    var ps0 = pubsub();
    if (ps0.sub) { try { ps0.sub(ps0.ev.cartUpdate, function () { refreshCart().then(paintShip); }); } catch (e) {} }
    var s0 = currentTier();
    if (s0) paint(s0);
    paintPack();
    refreshCart().then(paintShip);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
